

const CartReducer = (state, action) => {
    switch (action.type) {
        case "UPLOAD_CART_SUCCESS":
            return {
                ...state,
                // cart: [...state.cart,...action.payload],
                cart: action.payload,
            };
        case "REMOVE_FROM_CART":
            return {
                ...state,
                // cart: [...state.cart,...action.payload],
                cart: state.cart.filter(item => item.id !== action.payload),
            };
        case "CLEAR_CART":
            return {
                ...state,
                cart: [],
            };
        case "RESTART_CART":
            return {
                ...state,
                cart: [],
                message: "",
                messageEtat: "",
            };
        case "ADD_ACTION_START":
            return {
                ...state,
                message: "",
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_ACTION_SUCCESS":
            return {
                ...state,
                message: action.payload,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_ACTION_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "ADD_ACTION_ETAT_START":
            return {
                ...state,
                messageEtat: "",
                isFetchingEtatAdd: true,
                errorEtatAdd: false,
            };
        case "ADD_ACTION_ETAT_SUCCESS":
            return {
                ...state,
                messageEtat: action.payload,
                isFetchingEtatAdd: false,
                errorEtatAdd: false,
            };
        case "ADD_ACTION_ETAT_FAILURE":
            return {
                ...state,
                messageEtat: "",
                isFetchingEtatAdd: false,
                errorEtatAdd: action.payload,
            };
        case "GET_CART_ENVOIE_START":
            return {
                ...state,
                isFetchingGetOne: true,
                errorGetOne: false,
            };
        case "GET_CART_ENVOIE_SUCCESS":
            return {
                ...state,
                cart: [action.payload.envoie,...state.cart],
                isFetchingGetOne: false,
                errorGetOne: false,
            };
        case "GET_CART_ENVOIE_FAILURE":
            return {
                ...state,
                isFetchingGetOne: false,
                errorGetOne: action.payload,
            };
        default:
            return { ...state };
    }
}

export default CartReducer;